// Games are expected to already be sorted by start time (matches CustomerView's
// existing sort) — this helper does not re-sort, only slices.
export function getUpcomingPreview(games, previewCount, expanded) {
  const list = games || [];
  if (expanded || list.length <= previewCount) {
    return { visible: list, hasMore: false, remainingCount: 0 };
  }
  return {
    visible: list.slice(0, previewCount),
    hasMore: true,
    remainingCount: list.length - previewCount,
  };
}
